import { z } from 'zod';
/**
 * One PM from a TG service account (777000 / 42777) captured for a
 * managed account. Phase 1: raw text only; parsedLoginCode reserved
 * for Phase 2 once we've seen what real messages look like.
 */
export const AccountSystemMessageItem = z.object({
    id: z.string().uuid(),
    senderUserId: z.string(),
    tgMessageId: z.string(),
    text: z.string(),
    parsedLoginCode: z.string().nullable(),
    receivedAt: z.string().datetime(),
});
export const ListAccountSystemMessagesResponse = z.object({
    items: z.array(AccountSystemMessageItem),
});
//# sourceMappingURL=account-system-message.js.map